<template>
  <DialogHeader class="items-center">
    <SuccessIcon />
    <DialogTitle>Sent Successfully</DialogTitle>
    <DialogDescription>Your response has been sent to the shopper.</DialogDescription>
  </DialogHeader>

  <div class="h-[1px] w-full my-4 bg-grey-light-200" />

  <DialogFooter>
    <Button @click="close">Done</Button>
  </DialogFooter>
</template>

<script setup lang="ts">
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import { Button } from '@/components/ui/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import DialogDescription from '@/components/ui/dialog/DialogDescription.vue';

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>
